/**
 * Template — high-level visual layout family selected per session. Picks
 * which `templates/<name>` page tree renders. Theme tokens (palette,
 * overrides) are layered on top regardless of template.
 */
export type Template = 'classic' | 'modern';
export const TEMPLATES: readonly Template[] = ['classic', 'modern'] as const;
export const DEFAULT_TEMPLATE: Template = 'classic';

export type ThemeSource = 'backend' | 'url' | 'default';
